export const characterWithSpaceRegex = /^[a-zA-Z ]*$/
export const mobileNumberRegex = /^[6789]\d{9}$/
export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const numberRegex = /[0-9]*$/
export const addressRegex = /^[a-zA-Z0-9\s,.'-]*$/
